import find from 'lodash/find';

export default {
	navigation: state => {
		return state.navigation;
	},

	station: (state, getters, rootState, rootGetters) => {
		return find(rootGetters['orm/stations'], ['station', state.station]) || state.station;
	},


	startstation: (state, getters, rootState, rootGetters) => {
		return find(rootGetters['orm/stations'], ['station', state.station]) || state.station;
	},
	endstation: (state, getters, rootState, rootGetters) => {
		return find(rootGetters['orm/stations'], ['station', state.station]) || state.station;
	},

	startdate: state => {
		return state.startdate;
	},
	enddate: state => {
		return state.enddate;
	},

	car: state => {
		return state.car;
	},

	price: state => (groupKey) => {
		return find(state.prices, ['groupKey', groupKey]);
	},

	prices: state => {
		return state.prices;
	},

	private_reservations: state => {
		return state.private_reservations;
	},

	rentaltype: state => {
		return state.rentaltype;
	},

	

	rentalcomment: state => {
		return state.rentalcomment;
	},

	billKey: state => {
		return state.billKey;
	},

	voucher: state => {
		return state.voucher;
	},

	estimated_km: state => {
		return state.estimated_km;
	},

	user_session: state => {
		return state.user_session;
	},
	sid: state => {
		return state.user_session;
	}
};



// WEBPACK FOOTER //
// ./src/store/orm/reservation/getters.js